<!-- =========================================================================================
    File Name: EmployeesAddNew.vue
    Description: Add new Employees
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">

        <h4> {{ $t("EmployeeCreateDescription") }} </h4> <br/>

        <form @submit.prevent="submitForm">

            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <vs-input icon-pack="fa" icon="fa-user" class="w-full" label-placeholder="Employee Name" v-model="PartyName" v-validate="'required'" name="PartyName" />
                    <span class="text-danger text-sm" v-show="errors.has('PartyName')">{{ errors.first('PartyName') }}</span>
                </div>

                <!-- <div class="vx-col sm:w-1/2 w-full mb-3">
                    <vs-input icon-pack="fa" icon="fa-users" class="w-full" label-placeholder="Employee Company Name" v-model="PartyCompanyName" v-validate="'required'" name="PartyCompanyName" />
                    <span class="text-danger text-sm" v-show="errors.has('PartyCompanyName')">{{ errors.first('PartyCompanyName') }}</span>
                </div> -->
            </div>

            <p> {{ $t("LedgerDetails") }} </p>

            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm">
                        {{ $t("CreditDebit") }}
                    </span>                
                    <v-select v-model="CreditDebit" name="CreditDebit" :value="CreditDebit" :options="CreditDebitOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('CreditDebit')">{{ errors.first('CreditDebit') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input icon-pack="fa" icon="fa-rupee-sign" class="w-full" label-placeholder="Opening Balance" v-model="OpeningBalance" v-validate="'required|decimal:2|min_value:0'" name="OpeningBalance" />
                    <span class="text-danger text-sm" v-show="errors.has('OpeningBalance')">{{ errors.first('OpeningBalance') }}</span>
                </div>
            </div>

            <!-- <p> {{ $t("PriceGroup") }} </p>

            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm">
                        {{ $t("EmployeePriceGroup") }}
                    </span>
                    <v-select v-model="PriceGroupId" name="PriceGroupId" :value="PriceGroupId" :options="PriceGroupIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" placeholder="Price Group" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('PriceGroupId')">{{ errors.first('PriceGroupId') }}</span>
                </div>
            </div> -->

            <p>More Information</p>

            <div class="vx-row">
                <div class="vx-col w-full mb-3">
                    <vs-textarea counter="100" label="Address" :counter-danger.sync="counterDanger" v-model="Address" v-validate="'required'" />
                    <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label">
                        {{ $t("State") }}
                    </span>
                    <v-select v-model="StateId" name="StateId" :value="StateId" :options="StateIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" v-on:input="getDistrictOptions()" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('StateId')">{{ errors.first('StateId') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label">
                        {{ $t("District") }}
                    </span>
                    <v-select v-model="DistrictId" name="DistrictId" :value="DistrictId" :options="DistrictIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" v-on:input="getCityOptions()" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('DistrictId')">{{ errors.first('DistrictId') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label">
                        {{ $t("City") }}
                    </span>
                    <v-select v-model="CityId" name="CityId" :value="CityId" :options="CityIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('CityId')">{{ errors.first('CityId') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input icon="phone_android" class="w-full" label-placeholder="Contact Number" v-model="ContactNumber"  name="ContactNumber" v-validate="'required|numeric|min:10'" :maxlength="10" />
                    <span class="text-danger text-sm" v-show="errors.has('ContactNumber')">{{ errors.first('ContactNumber') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input icon="chat" class="w-full" label-placeholder="Whatsapp Number" v-model="WhatsappNumber"  name="WhatsappNumber" v-validate="'numeric|min:10'" :maxlength="10" />
                    <span class="text-danger text-sm" v-show="errors.has('WhatsappNumber')">{{ errors.first('WhatsappNumber') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input icon-pack="fa" icon="fa-whatsapp" class="w-full" label-placeholder="Landline" v-model="Landline" name="Landline" v-validate="'numeric|min:10'" :maxlength="15" />
                    <span class="text-danger text-sm" v-show="errors.has('Landline')">{{ errors.first('Landline') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <!-- <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input icon="library_books" class="w-full" label-placeholder="GST Number" v-model="GstNumber" name="GstNumber" v-validate="'min:15'" :maxlength="15" />
                    <span class="text-danger text-sm" v-show="errors.has('GstNumber')">{{ errors.first('GstNumber') }}</span>
                </div> -->

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input icon="credit_card" class="w-full" label-placeholder="PAN" v-model="PartyPan" name="PartyPan" v-validate="'min:10'" :maxlength="10" />
                    <span class="text-danger text-sm" v-show="errors.has('PartyPan')">{{ errors.first('PartyPan') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label">
                        {{ $t("Login") }}
                    </span>
                    <v-select v-model="CreateLogin" name="CreateLogin" :value="CreateLogin" :options="CreateLoginOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('CreateLogin')">{{ errors.first('CreateLogin') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label">
                        {{ $t("Status") }}
                    </span>
                    <v-select v-model="ActiveStatus" name="ActiveStatus" :value="ActiveStatus" :options="ActiveStatusOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('ActiveStatus')">{{ errors.first('ActiveStatus') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Image1" v-model="Image1" name="Image1" />
                    <span class="text-danger text-sm" v-show="errors.has('Image1')">{{ errors.first('Image1') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Image2" v-model="Image2" name="Image2" />
                    <span class="text-danger text-sm" v-show="errors.has('Image2')">{{ errors.first('Image2') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full mb-3">
                    <vs-textarea counter="100" label="Employee Tamil Name" :counter-danger.sync="counterDanger" v-model="PartyTamilName" />
                    <span class="text-danger text-sm" v-show="errors.has('PartyTamilName')">{{ errors.first('PartyTamilName') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full text-right">
                    <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                    <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                </div>
            </div>                    
        </form>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import { Validator } from 'vee-validate';

import vSelect from 'vue-select'

const dict = {
  custom: {
    PartyName: { required: 'Employee Name should not be empty' },
    PartyCompanyName: {
        required: 'Employee Company Name should not be empty'
    },
    CreditDebit: {
        required: 'Credit / Debit should not be empty',
        numeric: 'Credit / Debit is invalid', 
    },
    OpeningBalance: {
        required: 'Opening Balance should not be empty',
        min_value: 'Opening Balance should be greater than 0', 
        decimal: 'Opening Balance accepted only 2 decimal places', 
    },
    PriceGroupId: {
        required: 'Price Group should not be empty',
        numeric: 'Price Group is invalid', 
    },
    Address: { required: 'Address should not be empty' },
    StateId: { required: 'State Name should not be empty' },
    DistrictId: { required: 'District Name should not be empty' },
    CityId: { required: 'City Name should not be empty' },
    ContactNumber: {
        required : 'Contact Number should not be empty',
        numeric: 'Contact Number is invalid', 
        min: 'Contact Number shoult contain 10 digits', 
    },
    WhatsappNumber: {
        numeric: 'Whatsapp Number is invalid', 
        min: 'Whatsapp Number shoult contain 10 digits', 
    },
    Landline: {
        numeric: 'Lanline is invalid',
        min: 'Landline shoult contain 10 characters', 
    },    
    GstNumber: {
        min: 'GST Number shoult contain 15 characters', 
    },
    PartyPan: {
        min: 'PAN shoult contain 10 characters', 
    },
    CreateLogin: {
        required: 'Create Login should not be empty',
        numeric: 'Create Login is invalid', 
    },
    ActiveStatus: {
        required: 'Active Status should not be empty',
        numeric: 'Active Status is invalid', 
    },
  }
};

// register custom messages
Validator.localize('en', dict);

export default {
    mixins: [common],
    components: {
        'v-select': vSelect,
    },    
    props: {
        addRecordPrompt: {
            type: Boolean,
            required: true,
        },
    },    
    data() {
        return {
            activePrompt: true,

            CreditDebitOptions : this.selectListCreditDebit(),
            CreateLoginOptions : this.selectListYesNo(),
            ActiveStatusOptions : this.selectListActiveStatus(),

            PartyCategoryId: 3,
            LedgerGroupId: 5,
            PartyName : '',
            PartyCompanyName : '',
            CreditDebit : '',
            OpeningBalance : '',
            PriceGroupId : 1,
            Address : '',
            StateId : "",
            DistrictId : "",
            CityId : "",
            ContactNumber : '',
            WhatsappNumber : '',
            Landline : '',
            GstNumber : '',
            PartyPan : '',            
            CreateLogin : '0',
            Image1 : '',
            Image2 : '',
            ActiveStatus : '1',
            PartyTamilName : '',            
            PriceGroupIdOptions : [],
            StateIdOptions : [],
            DistrictIdOptions : [],
            CityIdOptions : [],
            counterDanger: false,

            recordObj: {},
            record: {},
        }
    },
    computed: {
        dataArrayLength() {
            return this.$store.getters['allParty/dataArrayLength'];
        },
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideAddRecordPrompt');
        },
        addRecordDetails() {
            // add todo in store and clear all fields in dialog

            this.recordObj.PartyCategoryId =  this.PartyCategoryId;
            this.recordObj.LedgerGroupId =  this.LedgerGroupId;
            this.recordObj.PartyName =  this.PartyName;
            this.recordObj.PartyCompanyName =  this.PartyCompanyName;
            this.recordObj.CreditDebit =  this.CreditDebit;
            this.recordObj.OpeningBalance =  this.OpeningBalance;
            this.recordObj.PriceGroupId =  this.PriceGroupId;
            this.recordObj.Address =  this.Address;
            this.recordObj.StateId =  this.StateId;
            this.recordObj.DistrictId =  this.DistrictId;
            this.recordObj.CityId =  this.CityId;
            this.recordObj.ContactNumber =  this.ContactNumber;
            this.recordObj.WhatsappNumber =  this.WhatsappNumber;
            this.recordObj.Landline =  this.Landline;
            this.recordObj.GstNumber =  this.GstNumber;
            this.recordObj.PartyPan =  this.PartyPan;
            this.recordObj.CreateLogin =  this.CreateLogin;
            this.recordObj.Image1 =  this.Image1;
            this.recordObj.Image2 =  this.Image2;
            this.recordObj.ActiveStatus =  this.ActiveStatus;
            this.recordObj.PartyTamilName =  this.PartyTamilName;

            var server_url=companyConfig.apiURL;
            this.record.token=this.$session.get('token');
            this.record.add_url=server_url+'lib/api/party/party/create';
            this.record.form=this.recordObj;
            this.record.list_url=server_url+'lib/api/party/party/lists';
            this.record.list_where={
                "party_details_party_category_id >=" : 1
            };
            console.log('record='+JSON.stringify(this.record));
            this.record.loading=this.$vs.loading;
            this.record.notify=this.$vs.notify;
            this.record.http=this.$http;            
            this.$store.dispatch('allParty/addRecordDetails', this.record);

            this.closePrompt();
        },
        clearFields() {
            // clear all fileds in todo
            this.PartyName =  '';
            this.PartyCompanyName =  '';
            this.CreditDebit =  '';
            this.OpeningBalance =  '';
            this.PriceGroupId =  '';
            this.Address =  '';
            this.StateId =  '';
            this.DistrictId =  '';
            this.CityId =  '';
            this.ContactNumber =  '';
            this.WhatsappNumber =  '';
            this.Landline =  '';
            this.GstNumber =  '';
            this.PartyPan =  '';
            this.CreateLogin =  '';
            this.Image1 =  '';
            this.Image2 =  '';
            this.ActiveStatus =  '';
            this.PartyTamilName =  '';

            this.closePrompt();
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if(result) {
                    this.addRecordDetails();
                }else{
                    console.log('form have errors`');
                    
                }
            });
        },
        getDistrictOptions(){
            console.log('getDistrictOptions is called');
            console.log('StateIdOptions='+JSON.stringify(this.StateIdOptions));
            var tempStateId=this.StateId;
            console.log('tempStateId='+tempStateId);
            if (tempStateId != "") {
                var selectbox4_source = 'DistrictId'
                var selectbox4_destination = 'DistrictIdOptions'
                var selectbox4_url = 'lib/api/data/get_district_options'
                var selectbox4_conditions_array = {
                    'district_details_state_details_id': tempStateId
                }
                this.getSelectBoxOptions(selectbox4_source, selectbox4_destination, selectbox4_conditions_array, selectbox4_url)
            }
        },
        getCityOptions(){
            console.log('getCityOptions is called');
            console.log('DistrictIdOptions='+JSON.stringify(this.DistrictIdOptions));
            var tempDistrictId=this.DistrictId;
            console.log('tempDistrictId='+tempDistrictId);
            if (tempDistrictId != "") {
                var selectbox5_source = 'CityId'
                var selectbox5_destination = 'CityIdOptions'
                var selectbox5_url = 'lib/api/data/get_city_options'
                var selectbox5_conditions_array = {
                    'city_details_district_details_id': tempDistrictId
                }
                this.getSelectBoxOptions(selectbox5_source, selectbox5_destination, selectbox5_conditions_array, selectbox5_url)
            }
        },        
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            const token=this.$session.get('token');
            console.log('token='+token);
            
            var selectbox1_source = 'PriceGroupId'
            var selectbox1_destination = 'PriceGroupIdOptions'
            var selectbox1_url = 'lib/api/data/get_party_price_group_options'
            var selectbox1_conditions_array = {
                'price_group_id > ': 0
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url)
            
            var selectbox3_source = 'StateId'
            var selectbox3_destination = 'StateIdOptions'
            var selectbox3_url = 'lib/api/data/get_states_options'
            var selectbox3_conditions_array = {
                'state_details_id > ': 0
            }
            this.getSelectBoxOptions(selectbox3_source, selectbox3_destination, selectbox3_conditions_array, selectbox3_url)
            
        }
    },
    watch: {
        
        PriceGroupIdOptions: function(){
            console.log('watch PriceGroupIdOptions='+JSON.stringify(this.PriceGroupIdOptions));
            var n1=this.PriceGroupIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.PriceGroupIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.PriceGroupId;                
                var str2=str1.toString();
                var index = this.PriceGroupIdOptions.map(e => e.value).indexOf(str1);
                console.log('str1='+str1+', str2='+str2+', index='+index);
                this.PriceGroupId=str2 != "" ? str2 : temp;
            }
        },        
        StateIdOptions: function(){            
            console.log('watch StateIdOptions='+JSON.stringify(this.StateIdOptions));
            var n1=this.StateIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.StateIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.StateId;
                var str2=str1.toString();
                console.log('str1='+str1+', str2='+str2);                
                this.StateId=str2 != "" ? str2 : temp;
            }
        },
        DistrictIdOptions: function(){
            console.log('watch DistrictIdOptions='+JSON.stringify(this.DistrictIdOptions));
            var n1=this.DistrictIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.DistrictIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.DistrictId;                
                var str2=str1.toString();
                var index = this.DistrictIdOptions.map(e => e.value).indexOf(str1);
                console.log('str1='+str1+', str2='+str2+', index='+index);
                this.DistrictId=index > 0 ? str2 : "";
            }
        },
        CityIdOptions: function(){
            console.log('watch CityIdOptions='+JSON.stringify(this.CityIdOptions));
            var n1=this.CityIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.CityIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.CityId;                
                var str2=str1.toString();
                var index = this.CityIdOptions.map(e => e.value).indexOf(str1);
                console.log('str1='+str1+', str2='+str2+', index='+index);
                this.CityId=index > 0 ? str2 : "";
            }
        },
    },
}
</script>
<style>
.con-vs-popup .vs-popup {
    width: 850px;
}
</style>